import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5814217e: FaireBrandEntity = {
  token: "b_5814217e",
  type: "brand",
  name: "Michael Michaud",
  avatarUrl:
    "https://cdn.faire.com/fastly/eae998c16ab00aa4763417b064aeb7ba883882f195ecb1d6b4d799e72d3a61f2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5d28c83b7e999901e6a8e76eabe6587e5d84fbee28cc746c11c3e54727381f14.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eae998c16ab00aa4763417b064aeb7ba883882f195ecb1d6b4d799e72d3a61f2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5d28c83b7e999901e6a8e76eabe6587e5d84fbee28cc746c11c3e54727381f14.jpeg",
  location: "Bellmore, NY, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 101,
  isTopShop: true,
  isInsider: true,
  description:
    "The Michael Michaud Design Jewelry Collection, designed by Michael Michaud, is a world-renowned collection of botanical jewelry. It captures the beauty and exquisite detail of nature using soft patinas on bronze accented with pearls, beads, stones, and more. His attention to intricate detail results in true to nature, botanical jewelry.\n\nThis unique jewelry is made by creating molds directly from botanical elements in a process similar to lost-wax casting. While traditional lost-wax casting begins with a hand-carved model of wax, Michael Michaud instead uses an actual leaf, branch, or flower in place of the wax model. A mold is created around the botanical element and, as it is heated, the plant matter burns away and leaves behind a beautifully detailed mold of itself.\n\nMichael Michaud Jewelry is renowned for its beauty and workmanship and is featured in the finest museums, galleries, and specialty retailers around the world. Many collections are commissioned by leading museums such as The Victoria & Albert Museum, The Art Institute of Chicago, The National Gallery of Art, and the Château de Versailles.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:59.688Z",
    importedBy: "entity-db-cli",
  },
};
